import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import SkeletonHeadlineText from './Skeleton'

import useStyles from './styles'

function HeadlineText({ headlineText, isHeadlineBlank, isInProgress, className, skeletonClassName, isCarousel }) {
  const classes = useStyles()

  if (isHeadlineBlank) return null

  return (
    <div className={classnames(classes.headlineText, className)}>
      {headlineText ? (
        headlineText
      ) : (
        <SkeletonHeadlineText isInProgress={isInProgress} count={isCarousel ? 2 : 1} className={skeletonClassName} />
      )}
    </div>
  )
}

HeadlineText.propTypes = {
  headlineText: PropTypes.string,
  isHeadlineBlank: PropTypes.bool,
  isInProgress: PropTypes.bool,
  className: PropTypes.string,
  skeletonClassName: PropTypes.string,
  isCarousel: PropTypes.bool
}

export default HeadlineText
